(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onero-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-onero-back-to-buy]');
    if (!link) return;
    event.preventDefault();

    const smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const picker = document.querySelector('.product-details variant-picker');

    if (mobile && picker) {
      // o menu do topo reaparece quando a página sobe: deixa ~100px livres em cima
      const offset = 100;
      const top = picker.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: smooth });
    } else {
      window.scrollTo({ top: 0, behavior: smooth });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onero-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('onero-faq')) {
    class OneroFaq extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKey(event, index));
        });

        this.querySelectorAll('.onero-faq__item').forEach((item) => {
          item.querySelector('summary').addEventListener('click', (event) => {
            event.preventDefault();
            this.toggle(item);
          });
        });
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
      }

      onKey(event, index) {
        const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        if (!(event.key in keys)) return;
        event.preventDefault();
        const next = (index + keys[event.key] + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      }

      toggle(item) {
        const answer = item.querySelector('.onero-faq__answer');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (item._animation) item._animation.cancel();

        if (!item.open) {
          item.open = true;
          item.classList.add('is-open');
          if (reduce) return;
          const height = answer.scrollHeight;
          item._animation = answer.animate(
            [{ height: '0px', opacity: 0 }, { height: height + 'px', opacity: 1 }],
            { duration: 400, easing: 'ease-out' }
          );
        } else {
          item.classList.remove('is-open');
          if (reduce) {
            item.open = false;
            return;
          }
          const height = answer.offsetHeight;
          item._animation = answer.animate(
            [{ height: height + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
            { duration: 250, easing: 'ease' }
          );
          item._animation.onfinish = () => {
            item.open = false;
            item._animation = null;
          };
        }
      }
    }

    customElements.define('onero-faq', OneroFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onero-featured-product"] && !Shopify.designMode) return;
  try {
    
  /* Se o tamanho que vem marcado está escondido (ex.: 15), marca o primeiro tamanho da lista. */
  class OneroFeatured extends HTMLElement {
    connectedCallback() {
      if (this.dataset.showSizes !== 'false') {
        customElements.whenDefined('variant-picker').then(() => requestAnimationFrame(() => this.pickAllowedSize()));
      }

      // na home não existe a janela do guia de tamanhos: o link leva pra página Sizing
      this.addEventListener(
        'click',
        (event) => {
          const link = event.target instanceof Element ? event.target.closest('.onero-sg-inline') : null;
          if (!link || document.querySelector('dialog-component.onero-size-guide')) return;
          event.preventDefault();
          event.stopPropagation();
          window.location.href = '/pages/sizing';
        },
        true
      );
    }

    pickAllowedSize() {
      const allowed = (this.dataset.sizes || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
      if (!allowed.length) return;

      const radios = [...this.querySelectorAll('variant-picker input[type="radio"]')].filter((input) =>
        /size/i.test(input.dataset.optionName || '')
      );
      const checked = radios.find((input) => input.checked);
      if (!checked || allowed.includes(checked.value)) return;

      const options = radios.filter((input) => allowed.includes(input.value));
      const target = options.find((input) => input.dataset.optionAvailable !== 'false') || options[0];
      target?.click();
    }
  }

  if (!customElements.get('onero-featured')) customElements.define('onero-featured', OneroFeatured);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onero-reveal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('onero-reveal')) {
    class OneroReveal extends HTMLElement {
      connectedCallback() {
        this.handle = this.querySelector('.onero-rv__handle');
        this.dragging = false;

        this.addEventListener('pointerdown', (e) => {
          if (e.button !== 0) return;
          this.dragging = true;
          this.setPointerCapture(e.pointerId);
          this.move(e.clientX);
        });
        this.addEventListener('pointermove', (e) => {
          if (this.dragging) this.move(e.clientX);
        });
        const stop = () => (this.dragging = false);
        this.addEventListener('pointerup', stop);
        this.addEventListener('pointercancel', stop);

        this.handle?.addEventListener('keydown', (e) => {
          const step = { ArrowLeft: -5, ArrowRight: 5 }[e.key];
          if (!step) return;
          e.preventDefault();
          this.set(this.pos() + step);
        });
      }

      pos() {
        return parseFloat(this.style.getPropertyValue('--pos')) || 50;
      }

      move(x) {
        const r = this.getBoundingClientRect();
        this.set(((x - r.left) / r.width) * 100);
      }

      set(value) {
        const v = Math.min(100, Math.max(0, value));
        this.style.setProperty('--pos', v + '%');
        this.handle?.setAttribute('aria-valuenow', Math.round(v));
      }
    }
    customElements.define('onero-reveal', OneroReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onero-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('onero-reviews')) {
    // ONÉRO (04/10): fotos que não valorizam a peça ficam escondidas (a review continua).
    // Chave = nome | 30 primeiras letras do texto | posição da foto. Vale pras cópias da review nos produtos de cor.
    const HIDE = [
      'Customer|It fit perfectly. I am 175cm t|0', 'Customer|Top quality, excellent product|0',
      'Customer|It fits a little tight, but I |0', 'JA|Good quality shirt, beautiful,|0',
      'ND|Tight around the arms, a bit b|0', 'JN|Second order, super satisfied.|0',
      'AZ|Quality trousers. The fabric look|0', 'Customer|Perfect fit, I really liked it|0',
      'PN|Nice athletic fit for a t-shir|0', "Customer|I don't even know what to say,|0",
      // 03/11 (Kauã): foto em que o rosto dele aparece (segurando a camisa)
      'Kauã França|I was genuinely surprised that|0',
    ];
    // Temas que quebram objeção: caimento/tamanho, tecido/qualidade, não amassa, conforto, valor/recompra.
    const TOPICS = [
      /\b(fit|fits|fitted|size|sizing|tall|cm|kg|weigh|chart)\b/i,
      /\b(fabric|quality|material|soft|well-made|classy)\b/i,
      /\b(iron|ironing|wrinkle|wrinkles|crease|creases)\b/i,
      /\b(comfort|comfortable|stretch|stretchy|moves?)\b/i,
      /\b(value|again|second|third|fourth|bought|recommend)\b/i,
    ];
    const NO_NAME = /^(customer|anonymous|)$/i;
    // Fixadas, cada uma na sua posição da lista (pos 0 = 1ª da página 1). Chave = nome | começo do texto.
    // Kauã em 1º (14/10), Moisés em 3º (22/10), as duas decisões do Kauã.
    const PIN = [
      { key: 'Kauã França|I was genuinely surprised', pos: 0 },
      { key: 'Moisés Rodrigues|I really liked it', pos: 2 },
    ];
    // Fotos a mais que entram na frente das fotos da review (o Judge.me não deixa editar review pronta).
    // Chave = igual ao PIN. 29/10: foto de espelho do Kauã com a camisa preta, 1ª das 3.
    const CLD = 'https://res.cloudinary.com/iczsu9ix/image/upload/';
    const EXTRA = {
      'Kauã França|I was genuinely surprised': ['v1793290216/onero-reviews/a6ftlna6aue5xpnl773n.jpg'],
    };
    const MAX_PHOTOS = 5;
    const MAX_BYTES = 10 * 1024 * 1024;

    class OneroReviews extends HTMLElement {
      connectedCallback() {
        this.pid = this.dataset.productId;
        this.shop = this.dataset.shop;
        this.perPage = parseInt(this.dataset.perPage, 10) || 3;
        this.cloud = this.dataset.cloud || '';
        this.preset = this.dataset.preset || '';
        this.page = 1;
        this.reviews = [];
        this.photos = [];
        this.star = this.querySelector('[data-star]').innerHTML;
        this.list = this.querySelector('[data-list]');
        this.pager = this.querySelector('[data-pager]');
        this.form = this.querySelector('[data-form]');
        this.rating = 0;

        this.querySelectorAll('[data-open-form]').forEach((b) => b.addEventListener('click', () => this.toggleForm(b)));
        this.querySelector('[data-close-form]').addEventListener('click', () => this.toggleForm(null, false));
        this.form.addEventListener('submit', (e) => this.submit(e));
        this.pager.addEventListener('click', (e) => {
          const b = e.target.closest('[data-page]');
          if (b && !b.disabled) this.show(parseInt(b.dataset.page, 10), true);
        });
        this.setupPick();
        this.setupPhotos();
        this.setupLightbox();

        // 14/10: load as soon as the page has finished and the browser is idle (never competes with the top
        // of the page). If the visitor scrolls here first, the observer starts it right away.
        const start = () => { if (this.started) return; this.started = true; io.disconnect(); this.loadAll(); };
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) start();
        }, { rootMargin: '1200px' });
        io.observe(this);
        const idle = () => ('requestIdleCallback' in window ? requestIdleCallback(start, { timeout: 3000 }) : setTimeout(start, 1500));
        if (document.readyState === 'complete') idle();
        else window.addEventListener('load', idle, { once: true });
      }

      url(page) {
        const p = new URLSearchParams({
          product_id: this.pid, page, per_page: 30, sort_by: 'created_at',
          sort_dir: 'desc', widget_theme: 'standard', shop_domain: this.shop, platform: 'shopify',
          // changes every hour: the Judge.me CDN kept an old copy (new reviews didn't show); now they show within 1 hour
          v: String(Math.floor(Date.now() / 36e5)),
        });
        return 'https://cdn.judge.me/reviews/reviews_for_widget?' + p.toString();
      }

      // O link devolve no máximo 30 por vez: a 1ª página diz o total, as outras vêm juntas, depois ordena aqui.
      // Fica guardado 1 hora no navegador (mesma hora do parâmetro v do link), então a 2ª página visitada é instantânea.
      async loadAll() {
        const key = 'orv:' + this.pid + ':' + Math.floor(Date.now() / 36e5);
        try {
          const saved = JSON.parse(localStorage.getItem(key) || 'null');
          if (saved && saved.first) { this.render(saved.first, saved.all); return; }
        } catch (e) {}
        try {
          const first = await (await fetch(this.url(1))).json();
          const total = first.number_of_reviews || 0;
          const all = [...(first.reviews || [])];
          const pages = Math.min(20, Math.ceil(total / 30));
          if (pages > 1 && all.length < total) {
            const more = await Promise.all(
              Array.from({ length: pages - 1 }, (_, i) => fetch(this.url(i + 2)).then((r) => r.json()).catch(() => ({})))
            );
            more.forEach((d) => all.push(...(d.reviews || [])));
          }
          this.render(first, all);
          try {
            Object.keys(localStorage).filter((k) => k.startsWith('orv:' + this.pid + ':') && k !== key).forEach((k) => localStorage.removeItem(k));
            const { reviews, ...summary } = first;
            localStorage.setItem(key, JSON.stringify({ first: summary, all }));
          } catch (e) {}
        } catch (e) {
          this.pager.hidden = true;
        }
      }

      render(first, all) {
        this.renderSummary(first);
        this.reviews = this.order(all);
        this.show(1, false);
      }

      text(r) {
        return (r.body_html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      }

      pics(r) {
        const base = (r.reviewer_name || '') + '|' + (r.body_html || '').replace(/<[^>]+>/g, '').slice(0, 30) + '|';
        const own = (r.pictures_urls || []).filter((p, i) => !HIDE.includes(base + i));
        const plain = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
        const t = plain(this.text(r));
        const key = Object.keys(EXTRA).find((k) => { const [n, s] = k.split('|'); return plain(r.reviewer_name) === plain(n) && t.startsWith(plain(s)); });
        if (!key) return own;
        const extra = EXTRA[key].map((p) => ({ compact: CLD + 'c_limit,w_400,q_auto,f_auto/' + p, huge: CLD + 'c_limit,w_1600,q_auto,f_auto/' + p }));
        return extra.concat(own);
      }

      score(r) {
        const rating = parseFloat(r.rating) || 0;
        const t = this.text(r);
        let s = rating * 10;
        if (!NO_NAME.test((r.reviewer_name || '').trim())) s += 6;
        s += Math.min(8, TOPICS.filter((re) => re.test(t)).length * 2);
        if (t.length >= 60) s += 2;
        if (t.length < 25) s -= 4;
        return s;
      }

      pinIndex(r) {
        // compares without accents or case ("ã" can come composed or split from Judge.me)
        const plain = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
        const name = plain(r.reviewer_name);
        const t = plain(this.text(r));
        return PIN.findIndex((k) => { const [n, s] = k.key.split('|'); return name === plain(n) && t.startsWith(plain(s)); });
      }

      // Páginas 1 e 2 = as melhores sem foto (4★+), com as fixadas encaixadas na posição delas;
      // depois todas as com foto (página 3, 22/10); depois o resto.
      order(all) {
        all.forEach((r) => { r._pics = (parseFloat(r.rating) || 0) <= 2 ? [] : this.pics(r); r._score = this.score(r); r._pin = this.pinIndex(r); });
        const byScore = (a, b) => b._score - a._score;
        const pinned = all.filter((r) => r._pin >= 0).sort((a, b) => PIN[a._pin].pos - PIN[b._pin].pos);
        const free = all.filter((r) => r._pin < 0);
        const withPics = free.filter((r) => r._pics.length).sort(byScore);
        const noPics = free.filter((r) => !r._pics.length).sort(byScore);
        const top = noPics.filter((r) => (parseFloat(r.rating) || 0) >= 4).slice(0, Math.max(0, this.perPage * 2 - pinned.length));
        const head = [...top];
        pinned.forEach((r) => head.splice(Math.min(PIN[r._pin].pos, head.length), 0, r));
        const rest = noPics.filter((r) => !top.includes(r));
        return [...head, ...withPics, ...rest];
      }

      show(page, scroll) {
        const pages = Math.max(1, Math.ceil(this.reviews.length / this.perPage));
        this.page = Math.min(Math.max(1, page), pages);
        const start = (this.page - 1) * this.perPage;
        this.list.innerHTML = '';
        this.reviews.slice(start, start + this.perPage).forEach((r) => this.list.appendChild(this.renderReview(r)));
        this.renderPager(pages);
        if (scroll) {
          const top = this.list.getBoundingClientRect().top;
          if (top < 80) window.scrollTo({ top: window.scrollY + top - 110, behavior: 'smooth' });
        }
      }

      renderPager(pages) {
        this.pager.hidden = pages < 2;
        if (pages < 2) { this.pager.innerHTML = ''; return; }
        const cur = this.page;
        const btn = (p, label, aria, extra) =>
          '<button type="button" class="orv__pg' + (extra || '') + '" data-page="' + p + '" aria-label="' + aria + '"' +
          (p === cur ? ' aria-current="page" disabled' : '') + '>' + label + '</button>';
        const first = Math.max(1, Math.min(cur - 1, pages - 2));
        const last = Math.min(pages, first + 2);
        let html = '';
        if (cur > 1) html += btn(1, '&laquo;', 'First page', ' orv__pg--arrow') + btn(cur - 1, '&lsaquo;', 'Previous page', ' orv__pg--arrow');
        for (let p = first; p <= last; p++) html += btn(p, String(p), 'Page ' + p);
        if (cur < pages) html += btn(cur + 1, '&rsaquo;', 'Next page', ' orv__pg--arrow') + btn(pages, '&raquo;', 'Last page', ' orv__pg--arrow');
        this.pager.innerHTML = html;
      }

      stars(value, cls) {
        let out = '';
        for (let i = 1; i <= 5; i++) {
          const fill = Math.max(0, Math.min(1, value - (i - 1)));
          out += '<span class="orv-star ' + (cls || '') + '" style="--fill:' + Math.round(fill * 100) + '%">' + this.star + this.star + '</span>';
        }
        return out;
      }

      renderSummary(d) {
        const total = d.number_of_reviews || 0;
        if (!total) { this.querySelector('[data-empty]').hidden = false; return; }
        const avg = parseFloat(d.average_rating) || 0;
        this.querySelector('[data-summary]').hidden = false;
        this.querySelector('[data-avg-stars]').innerHTML = this.stars(avg);
        this.querySelector('[data-avg-text]').textContent = avg.toFixed(2) + ' out of 5';
        this.querySelector('[data-avg-sub]').textContent = 'Based on ' + total + ' review' + (total === 1 ? '' : 's');
        const bars = this.querySelector('[data-bars]');
        bars.innerHTML = (d.histogram || []).map((h) =>
          '<div class="orv__bar-row"><span class="orv__stars orv__stars--sm">' + this.stars(h.rating) + '</span>' +
          '<span class="orv__bar"><span style="width:' + (h.percentage || 0) + '%"></span></span>' +
          '<span class="orv__bar-count">' + (h.frequency || 0) + '</span></div>'
        ).join('');
      }

      renderReview(r) {
        const el = document.createElement('article');
        el.className = 'orv__item';
        // ONÉRO (08/10): review de 1 ou 2 estrelas mostra só as estrelas e o nome (sem título, texto e fotos).
        if ((parseFloat(r.rating) || 0) <= 2) {
          el.innerHTML = '<span class="orv__stars orv__stars--sm">' + this.stars(r.rating) + '</span><p class="orv__name"></p>';
          el.querySelector('.orv__name').textContent = r.reviewer_name || 'Customer';
          return el;
        }
        const pics = (r._pics || []).map((p) =>
          '<button type="button" class="orv__pic" data-full="' + (p.huge || p.original) + '"><img src="' + (p.compact || p.small) + '" alt="" loading="lazy"></button>'
        ).join('');
        const title = r.title ? '<p class="orv__item-title"></p>' : '';
        el.innerHTML =
          '<span class="orv__stars orv__stars--sm">' + this.stars(r.rating) + '</span>' +
          '<p class="orv__name"></p>' + title +
          '<div class="orv__body">' + (r.body_html || '') + '</div>' +
          (pics ? '<div class="orv__pics">' + pics + '</div>' : '');
        el.querySelector('.orv__name').textContent = r.reviewer_name || 'Customer';
        if (r.title) el.querySelector('.orv__item-title').textContent = r.title;
        return el;
      }

      toggleForm(btn, force) {
        const open = force === undefined ? this.form.hidden : force;
        this.form.hidden = !open;
        this.querySelectorAll('[data-open-form]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
        if (open) this.form.querySelector('[data-pick] button').focus();
      }

      setupPick() {
        const btns = [...this.querySelectorAll('[data-pick] button')];
        const paint = (n) => btns.forEach((b, i) => b.classList.toggle('is-on', i < n));
        btns.forEach((b) => {
          const v = parseInt(b.dataset.value, 10);
          b.addEventListener('mouseenter', () => paint(v));
          b.addEventListener('click', () => {
            this.rating = v; paint(v);
            btns.forEach((x) => x.setAttribute('aria-checked', String(x === b)));
          });
        });
        this.querySelector('[data-pick]').addEventListener('mouseleave', () => paint(this.rating));
      }

      // Fotos: o seletor só abre no clique do botão. Até 5, jpg/png, até 10 MB cada.
      setupPhotos() {
        const add = this.querySelector('[data-add-photos]');
        if (!add) return;
        const input = this.querySelector('[data-file]');
        const msg = this.querySelector('[data-msg]');
        add.addEventListener('click', () => input.click());
        input.addEventListener('change', () => {
          msg.classList.remove('is-ok'); msg.textContent = '';
          for (const f of input.files) {
            if (this.photos.length >= MAX_PHOTOS) { msg.textContent = 'You can add up to ' + MAX_PHOTOS + ' photos.'; break; }
            if (!/^image\/(jpeg|png)$/.test(f.type)) { msg.textContent = 'Please choose JPG or PNG photos.'; continue; }
            if (f.size > MAX_BYTES) { msg.textContent = 'Each photo must be under 10 MB.'; continue; }
            this.photos.push({ file: f, url: URL.createObjectURL(f) });
          }
          input.value = '';
          this.renderThumbs();
        });
        this.querySelector('[data-thumbs]').addEventListener('click', (e) => {
          const x = e.target.closest('[data-remove]');
          if (!x) return;
          const [gone] = this.photos.splice(parseInt(x.dataset.remove, 10), 1);
          URL.revokeObjectURL(gone.url);
          this.renderThumbs();
        });
      }

      renderThumbs() {
        const box = this.querySelector('[data-thumbs]');
        if (!box) return;
        box.innerHTML = this.photos.map((p, i) =>
          '<span class="orv__thumb"><img src="' + p.url + '" alt=""><button type="button" data-remove="' + i + '" aria-label="Remove photo">&times;</button></span>'
        ).join('');
        const add = this.querySelector('[data-add-photos]');
        add.hidden = this.photos.length >= MAX_PHOTOS;
      }

      async uploadPhotos() {
        const urls = [];
        for (const p of this.photos) {
          const fd = new FormData();
          fd.append('file', p.file);
          fd.append('upload_preset', this.preset);
          const res = await fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(this.cloud) + '/image/upload', { method: 'POST', body: fd });
          const data = await res.json();
          if (!res.ok || !data.secure_url) throw new Error('upload');
          urls.push(data.secure_url);
        }
        return urls;
      }

      async submit(e) {
        e.preventDefault();
        const msg = this.querySelector('[data-msg]');
        const f = new FormData(this.form);
        const name = (f.get('name') || '').trim();
        const email = (f.get('email') || '').trim();
        const body = (f.get('body') || '').trim();
        msg.classList.remove('is-ok');
        if (!this.rating) { msg.textContent = 'Please choose a rating.'; return; }
        if (!name || !body || !/^\S+@\S+\.\S+$/.test(email)) { msg.textContent = 'Please fill in your name, a valid email and your review.'; return; }
        const btn = this.form.querySelector('[type="submit"]');
        btn.disabled = true;
        let pictureUrls = [];
        if (this.photos.length) {
          msg.textContent = 'Uploading photos…';
          try {
            pictureUrls = await this.uploadPhotos();
          } catch (err) {
            msg.textContent = 'A photo could not be uploaded. Please try again or remove it.';
            btn.disabled = false;
            return;
          }
        }
        msg.textContent = 'Sending…';
        try {
          // Sent as a plain form (no JSON): Judge.me answers 404 to the browser's CORS preflight,
          // so a JSON post is blocked by the browser. A form post has no preflight and works.
          const payload = new URLSearchParams({
            shop_domain: this.shop, platform: 'shopify', id: this.pid,
            name, email, rating: String(this.rating), title: (f.get('title') || '').trim(), body,
          });
          pictureUrls.forEach((u) => payload.append('picture_urls[]', u));
          const res = await fetch('https://judge.me/api/v1/reviews', { method: 'POST', body: payload });
          if (!res.ok) throw new Error(res.status);
          this.form.reset(); this.rating = 0;
          this.form.querySelectorAll('[data-pick] button').forEach((b) => { b.classList.remove('is-on'); b.setAttribute('aria-checked', 'false'); });
          this.photos.forEach((p) => URL.revokeObjectURL(p.url));
          this.photos = [];
          this.renderThumbs();
          msg.classList.add('is-ok');
          msg.textContent = 'Thank you! Your review was sent and will appear soon.';
        } catch (err) {
          msg.textContent = 'Something went wrong. Please try again in a moment.';
        }
        btn.disabled = false;
      }

      setupLightbox() {
        const box = this.querySelector('[data-lightbox]');
        const img = this.querySelector('[data-lightbox-img]');
        this.list.addEventListener('click', (e) => {
          const pic = e.target.closest('.orv__pic');
          if (!pic) return;
          img.src = pic.dataset.full; box.hidden = false;
        });
        box.addEventListener('click', (e) => {
          if (e.target === box || e.target.closest('[data-lightbox-close]')) { box.hidden = true; img.src = ''; }
        });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') box.hidden = true; });
      }
    }
    customElements.define('onero-reviews', OneroReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onero-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('onero-strip')) {
    class OneroStrip extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.onero-strip__list');
        this.buttons = [...this.querySelectorAll('.onero-strip__arrow')];
        if (!this.track) return;
        this.buttons.forEach((b) =>
          b.addEventListener('click', () => {
            const card = this.track.querySelector('.onero-strip__card');
            const step = card ? card.getBoundingClientRect().width : this.track.clientWidth;
            this.track.scrollBy({ left: step * Number(b.dataset.dir), behavior: 'smooth' });
          })
        );
        this.dots = [...this.querySelectorAll('.onero-strip__dot')];
        this.dots.forEach((d) =>
          d.addEventListener('click', () => {
            const card = this.track.querySelectorAll('.onero-strip__card')[Number(d.dataset.index)];
            if (card) this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
          })
        );
        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }

      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth - 2;
        const prev = this.querySelector('.onero-strip__arrow--prev');
        const next = this.querySelector('.onero-strip__arrow--next');
        if (prev) prev.disabled = t.scrollLeft <= 2;
        if (next) next.disabled = t.scrollLeft >= max;
        const i = Math.round(t.scrollLeft / (t.clientWidth || 1));
        this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      }
    }
    customElements.define('onero-strip', OneroStrip);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onero-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('onero-videos')) {
    class OneroVideos extends HTMLElement {
      connectedCallback() {
        this.cards = [...this.querySelectorAll('.onero-vd__card')];
        this.dialog = this.querySelector('.onero-vd__dialog');
        this.big = this.querySelector('.onero-vd__big');
        this.stage = this.querySelector('.onero-vd__stage');
        if (!this.dialog || !this.big) return;

        // Na página: toca mudo só quando aparece na tela
        this.observer = new IntersectionObserver(
          (entries) =>
            entries.forEach((e) => {
              const v = e.target;
              if (e.isIntersecting && !this.dialog.open) {
                v.muted = true;
                v.play().catch(() => {});
              } else {
                v.pause();
              }
            }),
          { threshold: 0.25 }
        );
        // 05/10: o vídeo só começa a baixar quando está chegando perto da tela
        this.loader = new IntersectionObserver(
          (entries) =>
            entries.forEach((e) => {
              if (!e.isIntersecting) return;
              const v = e.target;
              if (!v.getAttribute('src') && v.dataset.src) {
                v.preload = 'auto';
                v.src = v.dataset.src;
              }
              this.loader.unobserve(v);
            }),
          { rootMargin: '400px 0px' }
        );
        // 31/10: a capa também só baixa perto da tela (antes baixava junto com a foto principal)
        this.posterLoader = new IntersectionObserver(
          (entries) =>
            entries.forEach((e) => {
              if (!e.isIntersecting) return;
              const v = e.target;
              if (v.dataset.poster && !v.getAttribute('poster')) v.poster = v.dataset.poster;
              this.posterLoader.unobserve(v);
            }),
          { rootMargin: '800px 0px' }
        );
        // No computador a página rola por dentro e o vigia só vê o vídeo já na tela:
        // depois que a página termina de carregar, as capas entram de qualquer jeito.
        const fillPosters = () =>
          setTimeout(() => {
            this.cards.forEach((card) => {
              const v = card.querySelector('video');
              if (v.dataset.poster && !v.getAttribute('poster')) v.poster = v.dataset.poster;
            });
          }, 2000);
        if (document.readyState === 'complete') fillPosters();
        else window.addEventListener('load', fillPosters, { once: true });
        this.cards.forEach((card) => {
          const v = card.querySelector('video');
          this.posterLoader.observe(v);
          this.loader.observe(v);
          this.observer.observe(v);
          card.addEventListener('click', () => this.open(card, v));
        });

        // Aberto: clicar no vídeo pausa ou volta a tocar
        this.big.addEventListener('click', () => {
          if (this.big.paused) this.big.play().catch(() => {});
          else this.big.pause();
        });
        this.big.addEventListener('play', () => this.stage.classList.remove('is-paused'));
        this.big.addEventListener('pause', () => this.stage.classList.add('is-paused'));

        this.querySelector('.onero-vd__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.onClose());
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.loader?.disconnect();
        this.posterLoader?.disconnect();
      }

      open(card, small) {
        this.cards.forEach((c) => c.querySelector('video').pause());
        this.big.src = card.dataset.src;
        this.big.poster = small.poster || small.dataset.poster || '';
        this.big.muted = false;
        this.big.currentTime = 0;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.big.play().catch(() => {
          // Se o navegador bloquear o som, toca mudo mesmo
          this.big.muted = true;
          this.big.play().catch(() => {});
        });
      }

      onClose() {
        this.big.pause();
        this.big.removeAttribute('src');
        this.big.load();
        document.documentElement.style.overflow = '';
        this.cards.forEach((c) => {
          const v = c.querySelector('video');
          const r = v.getBoundingClientRect();
          if (r.bottom > 0 && r.top < window.innerHeight) v.play().catch(() => {});
        });
      }
    }
    customElements.define('onero-videos', OneroVideos);
  }

  } catch(e) { console.error(e); }
})();
})();
